import React from 'react';
// import PasswordRecoverySComponent from '../styles/forgotten.style';
import PasswordRecovery from '../components/PasswordRecovery';

function Forgotten() {
  return (
    // <PasswordRecoverySComponent>
    <PasswordRecovery />
    // </PasswordRecoverySComponent>
  );
}

export default Forgotten;
